import React from 'react';
import formatOrderDate from '../utils/formatOrderDate';

// "Sep 11, 2026 · 2:32 pm" for a table cell, with the time muted; a dash when missing.
const DateTimeText: React.FC<{ value?: string | null }> = ({ value }) => {
  const when = formatOrderDate(value);
  if (!when) return <span className="muted">—</span>;
  return (
    <>
      {when.date} <span className="muted dt-time">· {when.time}</span>
    </>
  );
};

export default DateTimeText;
